export class MoleculePanelOverviewHeaderMultiRestoreEmailActionComponent {
    public templateUrl = require('./multi-restore-email-mailbox-action.html?external');
}
